import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { OsNotificationService } from '../../../services/os-notification/os-notification.service';

@Component({
  selector: 'app-b-notification',
  template: '',
  standalone: true,
  imports: []
})
export class OsNotificationComponent implements OnInit, OnDestroy {
  permissionGranted = false;
  enableBrowserNotification = false; // QMA-1377 Disable Notification

  private enableBrowserNotificationSubscription: Subscription;

  constructor(private notificationService: OsNotificationService) {}

  ngOnInit() {
    this.enableBrowserNotificationSubscription = this.notificationService.enableBrowserNotifications$.subscribe(enabled => {
      this.enableBrowserNotification = enabled;

      // Only request permission if it's NOT already granted AND notifications are enabled.
      if (Notification.permission !== 'granted' && enabled) {
        this.requestPermission();
      }
    });

     this.notificationService.notificationStatus$.subscribe(status => {
        this.permissionGranted = status === 'granted';
     });
     this.enableBrowserNotification ? this.checkPermission() : null;
  }

  ngOnDestroy(): void {
    if(this.enableBrowserNotificationSubscription){
        this.enableBrowserNotificationSubscription.unsubscribe();
    }
  }


  async checkPermission(){
    if(Notification.permission === 'granted'){
        this.permissionGranted = true;
    }
  }

  async requestPermission() {
    await this.notificationService.requestPermission();
  }
}